export type ConfirmAction = {
  label: string;
  onClick: () => void;
  variant?: "primary" | "danger" | "outline" | "muted";
  disabled?: boolean;
};

const VARIANT: Record<NonNullable<ConfirmAction["variant"]>, string> = {
  primary: "bg-black text-white font-semibold",
  danger: "bg-red-600 text-white font-semibold",
  outline: "border border-gray-300 text-gray-700 font-semibold",
  muted: "bg-gray-100 text-gray-700",
};

/** Small centered confirm dialog matching the page's existing inline modals. */
export function ConfirmModal({
  title,
  children,
  actions,
  zIndexClass = "z-50",
}: {
  title: React.ReactNode;
  children: React.ReactNode;
  actions: ConfirmAction[];
  zIndexClass?: string;
}) {
  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center ${zIndexClass}`}
    >
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-sm text-gray-500 mb-4">{children}</p>
        <div className="flex gap-3 justify-end">
          {/* Keyed by index, not label: a label that changes mid-flight
              ("Void Invoice" -> "Voiding...") would remount and drop focus. */}
          {actions.map((a, i) => (
            <button
              key={i}
              onClick={a.onClick}
              disabled={a.disabled}
              className={`px-4 py-2 text-sm rounded-md disabled:opacity-50 ${
                VARIANT[a.variant ?? "muted"]
              }`}
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
